'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.userAccessRequest', [])

.factory('userAccessRequestService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/API/UserRequest';

    // **** Model
    service.getPendingSystems = function (request) {

        var bySystemID = {};

        // System Roles
        var sysRolesBySystemID = _.groupBy(request.SystemRolePendings, 'SystemID');

        Object.keys(sysRolesBySystemID).map(function (systemID) {
            var pendingsInSys = sysRolesBySystemID[systemID];
            var sysInfos = pendingsInSys[0];
            var pendingsNotProcessed = _.filter(pendingsInSys, function (pending) { return !pending.IsProcessed; });

            // Network Share
            if (sysInfos.SystemTypeID === 4) {
                if (_.isUndefined(bySystemID['Network Share'])) {
                    bySystemID['Network Share'] = {
                        SystemName: 'Network Shares',
                        SystemCssIcon: 'fa fa-hdd-o',
                        IsAllProcessed: pendingsNotProcessed.length === 0
                    }
                }
                else {
                    if (pendingsNotProcessed.length > 0) {
                        bySystemID['Network Share'].IsAllProcessed = false;
                    }
                }
            }
            // Other system type
            else {
                bySystemID[systemID] = {
                    SystemID: sysInfos.SystemID,
                    SystemName: sysInfos.SystemName,
                    SystemTypeID: sysInfos.SystemTypeID,
                    SystemCssIcon: _.isUndefined(sysInfos.SystemCssIcon) ? 'fa fa-laptop' : sysInfos.SystemCssIcon,
                    IsAllProcessed: pendingsNotProcessed.length === 0
                };
            }
        });

        // System Accounts
        var sysAccountsBySystemID = _.groupBy(request.SystemAccountPendings, 'SystemID');

        Object.keys(sysAccountsBySystemID).map(function (systemID) {
            var pendingsInSys = sysAccountsBySystemID[systemID];
            var pendingsNotProcessed = _.filter(pendingsInSys, function (pending) { return !pending.IsProcessed; });

            if (pendingsNotProcessed.length > 0 && !_.isUndefined(bySystemID[systemID])) {
                bySystemID[systemID].IsAllProcessed = false;
            }
        });

        // Return systemInfos
        var values = [];
        for (var bySystem in bySystemID) {
            if (Object.prototype.hasOwnProperty.call(bySystemID, bySystem)) {
                values.push(bySystemID[bySystem]);
            }
        }

        return _.sortBy(values, 'SystemName');
    }

    // **** HttpGet

    // Get Request
    service.getRequest = function (userAccessRequestId) {
        return $http.get(baseUrl + '/Get/' + userAccessRequestId, {})
            .then(function (response) {
                return response.data;
            });
    }

    // New Changes
    service.withNewsChangesForRequest = function (statusRequest, lastUpdateTimestampTicks, employeeId) {
        var url = baseUrl + '/WithNewsChangesForRequest' +
                  '?statusRequest=' + statusRequest +
                  '&lastUpdateTimestampTicks=' + lastUpdateTimestampTicks;
        if (!_.isUndefined(employeeId)) {
            url += '&employeeId=' + employeeId;
        }

        return $http.get(url)
                    .then(function (response) {
                        if (response.data === "true") return true;
                        return false;
                    });
    }

    // Followups
    service.getFollowupsByRequestID = function (userAccessRequestId) {
        return $http.get(baseUrl + '/Followup/GetByRequest/' + userAccessRequestId, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getFollowupByFollowup = function (followupId) {
        return $http.get(baseUrl + '/Followup/GetByFollowup/' + followupId, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // For List
    service.getUserRequestsByEmployee = function (params) {
        return $http.get(baseUrl + '/Manage?searchTerm=&page=' + params.page + '&employeeId=' + params.employeeId)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getAllUserRequests = function (params) {
        return $http.get(baseUrl + '/Manage?type=' + params.type + '&searchTerm=' + params.searchTerm + '&page=' + params.page)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getNotStartedUserRequests = function (params) {
        return $http.get(baseUrl + '/NotStarted?type=' + params.type + '&searchTerm=' + params.searchTerm + '&page=' + params.page)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getDraftUserRequests = function (params) {
        return $http.get(baseUrl + '/Draft?type=' + params.type + '&searchTerm=' + params.searchTerm + '&page=' + params.page)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getUnderReviewUserRequests = function (params) {
        return $http.get(baseUrl + '/UnderReview?type=' + params.type + '&searchTerm=' + params.searchTerm + '&page=' + params.page)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getPendingAuthorizationUserRequests = function (params) {
        return $http.get(baseUrl + '/PendingAuthorization?type=' + params.type + '&searchTerm=' + params.searchTerm + '&page=' + params.page)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getAuthorizedUserRequests = function (params) {
        return $http.get(baseUrl + '/PostDated?type=' + params.type + '&searchTerm=' + params.searchTerm + '&page=' + params.page)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getToProcessUserRequests = function (params) {
        var url = baseUrl + '/ToProcess?type=' + params.type + '&searchTerm=' + params.searchTerm +
                  '&page=' + params.page +
                  '&custodian=' + params.custodian;
        return $http.get(url)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getCompletedUserRequests = function (params) {
        return $http.get(baseUrl + '/Completed?type=' + params.type + '&searchTerm=' + params.searchTerm + '&page=' + params.page)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getOnHoldUserRequests = function (params) {
        return $http.get(baseUrl + '/OnHold?type=' + params.type + '&searchTerm=' + params.searchTerm + '&page=' + params.page)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getAssignedToMeRequests = function (params) {
        return $http.get(baseUrl + '/AssignedToMe?searchTerm=' + params.searchTerm + '&page=' + params.page)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getUnAssignedRequests = function (params) {
        return $http.get(baseUrl + '/UnAssigned?searchTerm=' + params.searchTerm + '&page=' + params.page)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getOnHoldUserAccessRequestsByEmployeeID = function (employeeId) {
        return $http.get(baseUrl + '/OnHold/ByEmployee/' + employeeId)
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Number of requests
    service.countRequests = function () {
        return $http.get(baseUrl + '/CountRequests')
                    .then(function (response) {
                        return response.data;
                    });
    }

    // **** HttpPost

    // Followup
    service.createFollowup = function (userAccessRequestId, comment, attachments) {
        return $http.post(baseUrl + '/Followup/CreateFollowup',
                          {
                             UserAccessRequestID: userAccessRequestId,
                             Comment: comment,
                             Attachments: attachments
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.cancelFollowup = function (userAccessRequestId, comment, attachments) {
        return $http.post(baseUrl + '/Followup/CancelFollowup',
                          {
                              UserAccessRequestID: userAccessRequestId,
                              Comment: comment,
                              Attachments: attachments
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Assign
    service.unAssignRequest = function (userAccessRequestId) {
        return $http.post(baseUrl + '/UnAssignRequest',
                          {
                              UserAccessRequestID: userAccessRequestId,
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.assignRequestToEmployee = function (userAccessRequestId, employeeId) {
        return $http.post(baseUrl + '/AssignRequestToEmployee',
                          {
                              UserAccessRequestID: userAccessRequestId,
                              EmployeeID: employeeId
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.assignRequestToCurrentUser = function (userAccessRequestId) {
        return $http.post(baseUrl + '/AssignRequestToCurrentUser',
                          {
                              UserAccessRequestID: userAccessRequestId,
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Create a new Request
    service.create = function (employeeId) {
        return $http.post(baseUrl + '/Create', { employeeId: employeeId })
                    .then(function (response) {
                        return response.data;
                    });
    }

    // Update request
    service.updateInfosForArrivalEvent = function (request) {
        return $http.post(baseUrl + '/' + request.UserAccessRequestID + '/ForArrivalEvent', {
            request: request
        })
        .then(function (response) {
            return response.data;
        });
    }

    return service;
}]);
